// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5c097b83","977":"82a8bb97"}[chunkId] + ".chunk.js";
};